(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elowen-product-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setup = (root) => {
      const carousel = root.querySelector('[data-elowen-carousel]');
      if (!carousel || carousel.dataset.ready === 'true') return;
      const track = carousel.querySelector('[data-elowen-track]');
      const cards = Array.from(carousel.querySelectorAll('[data-elowen-card]'));
      const previous = carousel.querySelector('[data-elowen-previous]');
      const next = carousel.querySelector('[data-elowen-next]');
      const dots = Array.from(carousel.querySelectorAll('[data-elowen-dot]'));
      if (!track || cards.length === 0) return;
      carousel.dataset.ready = 'true';
      let activeIndex = 0;
      let frame;
      const nearestIndex = () => {
        const left = track.scrollLeft;
        let best = 0;
        let distance = Infinity;
        cards.forEach((card, index) => {
          const current = Math.abs(card.offsetLeft - left);
          if (current < distance) { distance = current; best = index; }
        });
        return best;
      };
      const update = () => {
        activeIndex = nearestIndex();
        dots.forEach((dot, index) => {
          const selected = index === activeIndex;
          dot.classList.toggle('is-active', selected);
          if (selected) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
        });
        const max = Math.max(0, track.scrollWidth - track.clientWidth - 2);
        if (previous) previous.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
        const controlsVisible = track.scrollWidth > track.clientWidth + 2;
        if (previous) previous.hidden = !controlsVisible;
        if (next) next.hidden = !controlsVisible;
        const dotGroup = carousel.querySelector('[data-elowen-dots]');
        if (dotGroup) dotGroup.hidden = !controlsVisible;
      };
      const goTo = (index) => cards[Math.max(0, Math.min(index, cards.length - 1))].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      previous?.addEventListener('click', () => goTo(activeIndex - 1));
      next?.addEventListener('click', () => goTo(activeIndex + 1));
      dots.forEach((dot, index) => dot.addEventListener('click', () => goTo(index)));
      track.addEventListener('scroll', () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    };
    const setupAll = (scope = document) => scope.querySelectorAll('.elowen-products').forEach(setup);
    setupAll();
    document.addEventListener('shopify:section:load', (event) => setupAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iplus-bf-coupons"] && !Shopify.designMode) return;
  try {
    
(()=>{const copy=async t=>{try{await navigator.clipboard.writeText(t)}catch(e){window.prompt('Copy discount code:',t)}};document.querySelectorAll('.ibfc').forEach(s=>{const status=s.querySelector('[data-status]');s.querySelectorAll('[data-copy]').forEach(b=>b.addEventListener('click',async()=>{await copy(b.dataset.copy);b.textContent='Copied';if(status)status.textContent=`${b.dataset.copy} copied`;setTimeout(()=>{b.textContent='Copy';if(status)status.textContent=''},1600)}));s.querySelector('[data-copy-all]')?.addEventListener('click',async e=>{const text=[...s.querySelectorAll('[data-ticket]')].map(x=>`${x.dataset.code} — ${x.dataset.offer} — ${x.dataset.condition}`).join('\n');await copy(text);e.currentTarget.textContent='Collected';if(status)status.textContent='All discount codes copied';setTimeout(()=>{e.currentTarget.textContent='Collect All';if(status)status.textContent=''},1800)})})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iplus-bf-hero"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.ibfh__countdown[data-countdown]').forEach((timer)=>{const end=new Date(timer.dataset.countdown).getTime();if(Number.isNaN(end))return;let interval;const render=()=>{const d=Math.max(0,end-Date.now());const v={days:Math.floor(d/86400000),hours:Math.floor(d%86400000/3600000),minutes:Math.floor(d%3600000/60000),seconds:Math.floor(d%60000/1000)};Object.entries(v).forEach(([k,n])=>{const el=timer.querySelector(`[data-${k}]`);if(el)el.textContent=String(n).padStart(2,'0')});if(d===0)clearInterval(interval)};render();interval=setInterval(render,1000)});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iplus-bf-reviews"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-review-app]').forEach((root)=>{const prioritizePhotos=()=>{const selectors=['.jdgm-rev','.loox-review','.ryviu-review-item','.r--review-list-item','.spr-review','[data-review-id]','article'];const cards=[...root.querySelectorAll(selectors.join(','))].filter((card)=>card.parentElement&&card.closest('[data-review-app]')===root);const groups=new Map();cards.forEach((card)=>{const parent=card.parentElement;if(!groups.has(parent))groups.set(parent,[]);groups.get(parent).push(card)});groups.forEach((items,parent)=>{if(items.length<2)return;items.forEach((item,index)=>item.dataset.ibfrIndex=index);items.sort((a,b)=>{const aMedia=a.querySelector('img:not([src=""]),video,iframe[src*="youtube"],iframe[src*="vimeo"]')?1:0;const bMedia=b.querySelector('img:not([src=""]),video,iframe[src*="youtube"],iframe[src*="vimeo"]')?1:0;return bMedia-aMedia||Number(a.dataset.ibfrIndex)-Number(b.dataset.ibfrIndex)}).forEach(item=>parent.appendChild(item))})};let timer;const schedule=()=>{clearTimeout(timer);timer=setTimeout(prioritizePhotos,120)};new MutationObserver(schedule).observe(root,{childList:true,subtree:true});schedule()});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iplus-black-friday"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.bf__countdown[data-countdown]').forEach((timer) => {
      const end = new Date(timer.dataset.countdown).getTime();
      if (Number.isNaN(end)) return;
      const render = () => {
        const distance = Math.max(0, end - Date.now());
        const values = {
          days: Math.floor(distance / 86400000),
          hours: Math.floor((distance % 86400000) / 3600000),
          minutes: Math.floor((distance % 3600000) / 60000),
          seconds: Math.floor((distance % 60000) / 1000)
        };
        Object.entries(values).forEach(([key, value]) => {
          const node = timer.querySelector(`[data-${key}]`);
          if (node) node.textContent = String(value).padStart(2, '0');
        });
        if (distance === 0) clearInterval(interval);
      };
      let interval;
      render();
      interval = setInterval(render, 1000);
    });
    const copyText = async (text) => {
      try {
        await navigator.clipboard.writeText(text);
        return true;
      } catch (error) {
        window.prompt('Copy discount code:', text);
        return false;
      }
    };
    document.querySelectorAll('.bf__coupon-copy[data-copy-code]').forEach((button) => {
      button.addEventListener('click', async () => {
        const code = button.dataset.copyCode;
        if (!code) return;
        await copyText(code);
        const section = button.closest('.bf');
        const status = section?.querySelector('[data-copy-status]');
        button.textContent = 'Copied';
        if (status) status.textContent = `${code} copied to clipboard`;
        window.setTimeout(() => {
          button.textContent = 'Copy';
          if (status) status.textContent = '';
        }, 1600);
      });
    });
    document.querySelectorAll('.bf [data-collect-all]').forEach((button) => {
      button.addEventListener('click', async () => {
        const section = button.closest('.bf');
        const cards = section ? [...section.querySelectorAll('[data-coupon-card]')] : [];
        const codes = cards.map((card) => `${card.dataset.code} — ${card.dataset.offer} — ${card.dataset.condition}`).join('\n');
        if (!codes) return;
        await copyText(codes);
        const status = section.querySelector('[data-copy-status]');
        button.textContent = 'Collected';
        if (status) status.textContent = 'All discount codes copied to clipboard';
        window.setTimeout(() => {
          button.textContent = 'Collect All';
          if (status) status.textContent = '';
        }, 1800);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iplus-feature-story"] && !Shopify.designMode) return;
  try {
    
  function syncFeatureStoryTitles(root) {
    const sections = root.matches?.('.iplus-feature-story')
      ? [root]
      : root.querySelectorAll('.iplus-feature-story');

    sections.forEach((section) => {
      const source = section.querySelector('.iplus-feature-story__heading');
      if (!source) return;

      const sourceStyle = window.getComputedStyle(source);

      section.querySelectorAll('.iplus-feature-story__card-title').forEach((title) => {
        title.style.setProperty('font-family', sourceStyle.fontFamily, 'important');
        title.style.setProperty('font-style', sourceStyle.fontStyle, 'important');
        title.style.setProperty('font-weight', sourceStyle.fontWeight, 'important');
        title.style.setProperty('letter-spacing', sourceStyle.letterSpacing, 'important');
        title.style.setProperty('line-height', sourceStyle.lineHeight, 'important');
        title.style.setProperty('text-transform', sourceStyle.textTransform, 'important');
        title.style.setProperty('color', '#ffffff', 'important');
        title.style.setProperty('-webkit-text-fill-color', '#ffffff', 'important');
      });
    });
  }

  function initializeFeatureStoryTitles(root = document) {
    syncFeatureStoryTitles(root);
    if (document.fonts?.ready) {
      document.fonts.ready.then(() => syncFeatureStoryTitles(root));
    }
  }

  initializeFeatureStoryTitles();

  document.addEventListener('shopify:section:load', (event) => {
    initializeFeatureStoryTitles(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-video-carousel"] && !Shopify.designMode) return;
  try {
    

(function () {

  'use strict';


  /*
   * =======================================================
   * IPLUS VIDEO CAROUSEL
   *
   * Transform based carousel
   *
   * Shopify Pipeline compatible
   *
   * No jQuery
   * No third-party library
   * No scrollLeft
   * No scroll-snap
   * =======================================================
   */


  var initializedSections = [];


  /*
   * -------------------------------------------------------
   * EASING
   * -------------------------------------------------------
   */

  function easeOutCubic(t) {

    return 1 - Math.pow(1 - t, 3);

  }


  /*
   * -------------------------------------------------------
   * INITIALIZE
   * -------------------------------------------------------
   */

  function initializeCarousel(section) {

    if (!section) return;


    if (
      section.getAttribute(
        'data-ivc-initialized'
      ) === 'true'
    ) {

      return;

    }


    section.setAttribute(
      'data-ivc-initialized',
      'true'
    );


    initializedSections.push(
      section
    );


    var viewport =
      section.querySelector(
        '[data-ivc-viewport]'
      );


    var track =
      section.querySelector(
        '[data-ivc-track]'
      );


    var previous =
      section.querySelector(
        '[data-ivc-previous]'
      );


    var next =
      section.querySelector(
        '[data-ivc-next]'
      );


    if (
      !viewport ||
      !track
    ) {

      return;

    }


    var cards =
      Array.prototype.slice.call(
        track.querySelectorAll(
          '[data-ivc-card]'
        )
      );


    var videos =
      Array.prototype.slice.call(
        section.querySelectorAll(
          'video'
        )
      );


    if (!cards.length) {

      return;

    }


    var currentIndex = 0;

    var cardWidth = 0;

    var gap = 0;

    var isDragging = false;

    var dragStartX = 0;

    var dragStartTranslate = 0;

    var currentTranslate = 0;

    var animationTimer = null;

    var switchToken = 0;



    /*
     * -------------------------------------------------------
     * GET GAP
     * -------------------------------------------------------
     */

    function getGap() {

      var styles =
        window.getComputedStyle(
          track
        );


      var value =
        parseFloat(
          styles.columnGap ||
          styles.gap ||
          0
        );


      return isNaN(value)
        ? 0
        : value;

    }



    /*
     * -------------------------------------------------------
     * SET CARD WIDTH
     *
     * This avoids percentage width issues
     * inside max-content track.
     * -------------------------------------------------------
     */

    function calculateCardWidth() {

      gap =
        getGap();


      var viewportWidth =
        viewport.clientWidth;


      if (
        window.innerWidth <= 989
      ) {

        /*
          Mobile:
          70% card.
        */

        cardWidth =
          viewportWidth * 0.70;

      } else {

        /*
          Desktop:
          5 cards visible.
        */

        cardWidth =
          (
            viewportWidth -
            gap * 4
          ) / 5;

      }


      if (
        cardWidth < 1
      ) {

        return;

      }


      cards.forEach(
        function (card) {

          card.style.setProperty(
            '--ivc-card-width',
            cardWidth + 'px'
          );

        }
      );


      track.style.setProperty(
        '--ivc-card-width',
        cardWidth + 'px'
      );

    }



    /*
     * -------------------------------------------------------
     * GET TRACK WIDTH
     * -------------------------------------------------------
     */

    function getTrackWidth() {

      if (!cards.length) {

        return 0;

      }


      return (
        cards.length * cardWidth
      ) +
      (
        cards.length - 1
      ) *
      gap;

    }



    /*
     * -------------------------------------------------------
     * GET CENTERED TRANSLATE
     * -------------------------------------------------------
     */

    function getTranslateForIndex(
      index
    ) {

      var viewportWidth =
        viewport.clientWidth;


      var cardCenter =
        index *
        (
          cardWidth +
          gap
        ) +
        cardWidth / 2;


      var viewportCenter =
        viewportWidth / 2;


      /*
       * This is the important part.
       *
       * No fake left/right spacer.
       *
       * The track itself is translated.
       */

      return (
        viewportCenter -
        cardCenter
      );

    }



    /*
     * -------------------------------------------------------
     * STATIC GROUP POSITION
     *
     * For 1-4 videos we initially
     * center the whole group.
     *
     * For 5+ videos, show the first
     * 5 naturally without blank space.
     * -------------------------------------------------------
     */

    function getInitialTranslate() {

      var count =
        cards.length;


      var trackWidth =
        getTrackWidth();


      var viewportWidth =
        viewport.clientWidth;


      if (
        count <= 4
      ) {

        return (
          viewportWidth -
          trackWidth
        ) / 2;

      }


      /*
       * 5+ videos:
       * first 5 fill the viewport.
       */

      return 0;

    }



    /*
     * -------------------------------------------------------
     * APPLY TRANSFORM
     * -------------------------------------------------------
     */

    function applyTranslate(
      value,
      animate
    ) {

      if (!animate) {

        track.style.transition =
          'none';

      } else {

        track.style.transition =
          'transform 520ms cubic-bezier(0.22, 1, 0.36, 1)';

      }


      currentTranslate =
        value;


      track.style.transform =
        'translate3d(' +
        value +
        'px, 0, 0)';


      if (!animate) {

        /*
         * Force browser to acknowledge
         * the no-transition state.
         */

        track.offsetHeight;

        track.style.transition =
          'transform 520ms cubic-bezier(0.22, 1, 0.36, 1)';

      }

    }



    /*
     * -------------------------------------------------------
     * UPDATE ACTIVE VISUAL
     * -------------------------------------------------------
     */

    function updateActiveVisual() {

      cards.forEach(
        function (card, index) {

          if (
            index === currentIndex
          ) {

            card.classList.add(
              'is-active'
            );

          } else {

            card.classList.remove(
              'is-active'
            );

          }

        }
      );

    }



    /*
     * -------------------------------------------------------
     * PAUSE ALL VIDEOS
     * -------------------------------------------------------
     */

    function pauseAllVideos() {

      videos.forEach(
        function (video) {

          try {

            video.pause();

          } catch (error) {}

          video.muted = true;

          video.setAttribute(
            'muted',
            ''
          );

          video.dataset.ivcSound =
            'false';

        }
      );


      section
        .querySelectorAll(
          '[data-ivc-sound]'
        )
        .forEach(
          function (button) {

            button.classList.remove(
              'is-audible'
            );

            button.setAttribute(
              'aria-label',
              'Turn video sound on'
            );

          }
        );

    }



    /*
     * -------------------------------------------------------
     * PLAY ACTIVE VIDEO ONLY
     * -------------------------------------------------------
     */

    function playActiveVideo() {

      var card =
        cards[currentIndex];


      if (!card) return;


      var video =
        card.querySelector(
          'video'
        );


      if (!video) return;


      /*
       * First pause every other video.
       */

      videos.forEach(
        function (otherVideo) {

          if (
            otherVideo !== video
          ) {

            try {

              otherVideo.pause();

            } catch (error) {}

            otherVideo.muted =
              true;

          }

        }
      );


      /*
       * Keep active video muted
       * unless user explicitly enabled sound.
       */

      if (
        video.dataset.ivcSound !==
        'true'
      ) {

        video.muted =
          true;

      }


      video.setAttribute(
        'playsinline',
        ''
      );


      video.setAttribute(
        'webkit-playsinline',
        ''
      );


      /*
       * Only current video plays.
       */

      var promise =
        video.play();


      if (
        promise &&
        typeof promise.catch ===
        'function'
      ) {

        promise.catch(
          function () {}
        );

      }

    }



    /*
     * -------------------------------------------------------
     * SWITCH TO INDEX
     * -------------------------------------------------------
     */

    function switchTo(
      index,
      animate
    ) {

      if (
        !cards.length
      ) {

        return;

      }


      /*
       * Loop navigation.
       */

      if (
        index < 0
      ) {

        index =
          cards.length - 1;

      }


      if (
        index >= cards.length
      ) {

        index = 0;

      }


      currentIndex =
        index;


      switchToken += 1;

      var token =
        switchToken;


      /*
       * Stop current video immediately.
       */

      pauseAllVideos();


      /*
       * Update visual state immediately.
       */

      updateActiveVisual();


      /*
       * Cancel previous play timer.
       */

      if (
        animationTimer
      ) {

        window.clearTimeout(
          animationTimer
        );

      }


      var targetTranslate;


      /*
       * For a normal carousel:
       * center the active card.
       */

      targetTranslate =
        getTranslateForIndex(
          currentIndex
        );


      /*
       * For the initial static state,
       * don't create a blank area.
       */

      if (
        !animate &&
        cards.length <= 4
      ) {

        targetTranslate =
          getInitialTranslate();

      }


      applyTranslate(
        targetTranslate,
        animate
      );


      /*
       * Start video only after
       * transition has completed.
       */

      if (animate) {

        animationTimer =
          window.setTimeout(
            function () {

              if (
                token !==
                switchToken
              ) {

                return;

              }


              playActiveVideo();

            },
            520
          );

      } else {

        /*
         * Let layout settle first.
         */

        window.requestAnimationFrame(
          function () {

            if (
              token !==
              switchToken
            ) {

              return;

            }

            playActiveVideo();

          }
        );

      }

    }



    /*
     * -------------------------------------------------------
     * RESIZE
     * -------------------------------------------------------
     */

    var resizeTimer =
      null;


    function handleResize() {

      if (
        resizeTimer
      ) {

        window.clearTimeout(
          resizeTimer
        );

      }


      resizeTimer =
        window.setTimeout(
          function () {

            calculateCardWidth();


            /*
             * Recalculate without animation.
             */

            var target;


            if (
              cards.length <= 4
            ) {

              target =
                getInitialTranslate();

            } else {

              target =
                getTranslateForIndex(
                  currentIndex
                );

            }


            applyTranslate(
              target,
              false
            );

          },
          120
        );

    }


    window.addEventListener(
      'resize',
      handleResize
    );



    /*
     * -------------------------------------------------------
     * ARROWS
     * -------------------------------------------------------
     */

    if (previous) {

      previous.addEventListener(
        'click',
        function (event) {

          event.preventDefault();

          switchTo(
            currentIndex - 1,
            true
          );

        }
      );

    }


    if (next) {

      next.addEventListener(
        'click',
        function (event) {

          event.preventDefault();

          switchTo(
            currentIndex + 1,
            true
          );

        }
      );

    }



    /*
     * -------------------------------------------------------
     * KEYBOARD
     * -------------------------------------------------------
     */

    track.addEventListener(
      'keydown',
      function (event) {

        if (
          event.key ===
          'ArrowLeft'
        ) {

          event.preventDefault();

          switchTo(
            currentIndex - 1,
            true
          );

        }


        if (
          event.key ===
          'ArrowRight'
        ) {

          event.preventDefault();

          switchTo(
            currentIndex + 1,
            true
          );

        }

      }
    );



    /*
     * -------------------------------------------------------
     * DRAG / TOUCH
     * -------------------------------------------------------
     */

    var pointerStartX =
      0;

    var pointerCurrentX =
      0;

    var pointerActive =
      false;


    function getPointerX(event) {

      if (
        event.touches &&
        event.touches.length
      ) {

        return event.touches[0].clientX;

      }


      if (
        event.changedTouches &&
        event.changedTouches.length
      ) {

        return event.changedTouches[0].clientX;

      }


      return event.clientX;

    }


    function startDrag(event) {

      /*
       * Don't start carousel dragging
       * from the sound button.
       */

      var target =
        event.target;


      if (
        target &&
        target.closest &&
        target.closest(
          '[data-ivc-sound]'
        )
      ) {

        return;

      }


      pointerActive =
        true;


      pointerStartX =
        getPointerX(event);


      pointerCurrentX =
        pointerStartX;


      dragStartTranslate =
        currentTranslate;


      track.classList.add(
        'is-dragging'
      );


      /*
       * Stop video during drag.
       */

      pauseAllVideos();

    }


    function moveDrag(event) {

      if (!pointerActive) {

        return;

      }


      pointerCurrentX =
        getPointerX(event);


      var delta =
        pointerCurrentX -
        pointerStartX;


      /*
       * Prevent huge dragging.
       */

      var maxDrag =
        viewport.clientWidth * 0.85;


      if (
        delta > maxDrag
      ) {

        delta =
          maxDrag;

      }


      if (
        delta < -maxDrag
      ) {

        delta =
          -maxDrag;

      }


      track.style.transition =
        'none';


      currentTranslate =
        dragStartTranslate +
        delta;


      track.style.transform =
        'translate3d(' +
        currentTranslate +
        'px, 0, 0)';

    }


    function endDrag() {

      if (!pointerActive) {

        return;

      }


      pointerActive =
        false;


      track.classList.remove(
        'is-dragging'
      );


      var delta =
        pointerCurrentX -
        pointerStartX;


      var threshold =
        Math.max(
          45,
          viewport.clientWidth * 0.08
        );


      /*
       * Swipe left.
       */

      if (
        delta <
        -threshold
      ) {

        switchTo(
          currentIndex + 1,
          true
        );

        return;

      }


      /*
       * Swipe right.
       */

      if (
        delta >
        threshold
      ) {

        switchTo(
          currentIndex - 1,
          true
        );

        return;

      }


      /*
       * Not enough movement:
       * smoothly return to active card.
       */

      switchTo(
        currentIndex,
        true
      );

    }


    /*
     * Pointer events.
     */

    track.addEventListener(
      'pointerdown',
      startDrag
    );


    track.addEventListener(
      'pointermove',
      moveDrag
    );


    track.addEventListener(
      'pointerup',
      endDrag
    );


    track.addEventListener(
      'pointercancel',
      endDrag
    );


    track.addEventListener(
      'pointerleave',
      function () {

        if (
          pointerActive
        ) {

          endDrag();

        }

      }
    );


    /*
     * Prevent native image/video dragging.
     */

    track.addEventListener(
      'dragstart',
      function (event) {

        event.preventDefault();

      }
    );



    /*
     * -------------------------------------------------------
     * SOUND BUTTON
     * -------------------------------------------------------
     */

    var soundButtons =
      section.querySelectorAll(
        '[data-ivc-sound]'
      );


    Array.prototype.forEach.call(
      soundButtons,
      function (button) {

        button.addEventListener(
          'click',
          function (event) {

            event.preventDefault();

            event.stopPropagation();


            var card =
              button.closest(
                '[data-ivc-card]'
              );


            if (!card) return;


            var cardIndex =
              cards.indexOf(
                card
              );


            if (
              cardIndex < 0
            ) {

              return;

            }


            /*
             * If clicking sound on
             * a non-active card,
             * move it to center first.
             */

            if (
              cardIndex !==
              currentIndex
            ) {

              switchTo(
                cardIndex,
                true
              );


              /*
               * Enable sound after
               * transition.
               */

              var token =
                switchToken;


              window.setTimeout(
                function () {

                  if (
                    token !==
                    switchToken
                  ) {

                    return;

                  }


                  enableSound(
                    button,
                    card
                  );

                },
                540
              );


              return;

            }


            toggleSound(
              button,
              card
            );

          }
        );

      }
    );



    /*
     * -------------------------------------------------------
     * SOUND HELPERS
     * -------------------------------------------------------
     */

    function enableSound(
      button,
      card
    ) {

      var video =
        card.querySelector(
          'video'
        );


      if (!video) return;


      pauseAllVideos();


      /*
       * Restore active video state.
       */

      video.muted =
        false;

      video.dataset.ivcSound =
        'true';


      button.classList.add(
        'is-audible'
      );


      button.setAttribute(
        'aria-label',
        'Turn video sound off'
      );


      video.play().catch(
        function () {}
      );

    }


    function toggleSound(
      button,
      card
    ) {

      var video =
        card.querySelector(
          'video'
        );


      if (!video) return;


      var turnOn =
        video.muted;


      /*
       * Mute all other videos.
       */

      videos.forEach(
        function (otherVideo) {

          if (
            otherVideo !== video
          ) {

            otherVideo.muted =
              true;

            otherVideo.dataset.ivcSound =
              'false';

          }

        }
      );


      section
        .querySelectorAll(
          '[data-ivc-sound]'
        )
        .forEach(
          function (otherButton) {

            if (
              otherButton !== button
            ) {

              otherButton.classList.remove(
                'is-audible'
              );

              otherButton.setAttribute(
                'aria-label',
                'Turn video sound on'
              );

            }

          }
        );


      video.muted =
        !turnOn;


      video.dataset.ivcSound =
        turnOn
          ? 'true'
          : 'false';


      button.classList.toggle(
        'is-audible',
        turnOn
      );


      button.setAttribute(
        'aria-label',
        turnOn
          ? 'Turn video sound off'
          : 'Turn video sound on'
      );


      video.play().catch(
        function () {}
      );

    }



    /*
     * -------------------------------------------------------
     * VIDEO EVENTS
     *
     * IMPORTANT:
     * Only active video can play.
     * -------------------------------------------------------
     */

    videos.forEach(
      function (video) {

        /*
         * Remove autoplay if Shopify
         * has inserted it.
         */

        video.removeAttribute(
          'autoplay'
        );


        video.setAttribute(
          'preload',
          'metadata'
        );


        video.setAttribute(
          'playsinline',
          ''
        );


        video.setAttribute(
          'webkit-playsinline',
          ''
        );


        video.muted =
          true;


        video.dataset.ivcSound =
          'false';


        /*
         * Make sure every video starts paused.
         */

        try {

          video.pause();

        } catch (error) {}


        /*
         * If video becomes ready,
         * play ONLY if it is active.
         */

        video.addEventListener(
          'canplay',
          function () {

            var card =
              video.closest(
                '[data-ivc-card]'
              );


            if (!card) return;


            var index =
              cards.indexOf(
                card
              );


            if (
              index ===
              currentIndex
            ) {

              playActiveVideo();

            }

          }
        );

      }
    );



    /*
     * -------------------------------------------------------
     * INITIAL LAYOUT
     * -------------------------------------------------------
     */

    calculateCardWidth();


    /*
     * Initial active card:
     *
     * 1 video  -> 0
     * 2 videos -> 0
     * 3 videos -> 1
     * 4 videos -> 1
     * 5+       -> 2
     */

    if (
      cards.length <= 2
    ) {

      currentIndex =
        0;

    } else if (
      cards.length <= 4
    ) {

      currentIndex =
        Math.floor(
          (cards.length - 1) / 2
        );

    } else {

      currentIndex =
        2;

    }


    updateActiveVisual();


    /*
     * Static position:
     *
     * 1-4:
     * entire group centered,
     * no fake left blank.
     *
     * 5+:
     * natural first five-card layout.
     */

    var initialTranslate;


    if (
      cards.length <= 4
    ) {

      initialTranslate =
        getInitialTranslate();

    } else {

      initialTranslate =
        getTranslateForIndex(
          currentIndex
        );

    }


    applyTranslate(
      initialTranslate,
      false
    );


    /*
     * Play only initial active video.
     */

    window.requestAnimationFrame(
      function () {

        playActiveVideo();

      }
    );

  }



  /*
   * =======================================================
   * INITIALIZE ALL
   * =======================================================
   */

  function initializeAll() {

    var sections =
      document.querySelectorAll(
        '[data-ivc-section]'
      );


    Array.prototype.forEach.call(
      sections,
      function (section) {

        initializeCarousel(
          section
        );

      }
    );

  }



  /*
   * =======================================================
   * DOM READY
   * =======================================================
   */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initializeAll
    );

  } else {

    initializeAll();

  }



  /*
   * =======================================================
   * SHOPIFY PIPELINE / THEME EDITOR
   * =======================================================
   */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      var section =
        event.target;


      if (!section) return;


      var carousel =
        section.matches &&
        section.matches(
          '[data-ivc-section]'
        )
          ? section
          : section.querySelector &&
            section.querySelector(
              '[data-ivc-section]'
            );


      if (carousel) {

        /*
         * Shopify Theme Editor may
         * reload the same section.
         */

        carousel.removeAttribute(
          'data-ivc-initialized'
        );


        initializeCarousel(
          carousel
        );

      }

    }
  );

})();


  } catch(e) { console.error(e); }
})();
})();
